import type { Multiplier } from "./types";

export const GAME_RULES = Object.freeze({
  maxHearts: 3,
  totalEvents: 20,
  basePoints: 100,
  saturatedRewardPoints: 250,
  anchors: [0.5, 0.28, 0.72] as const,
  spawnY: 0.1,
  impactY: 0.84,
  phaseBreakMs: 700,
  phases: [
    { start: 1, end: 6, maxActive: 1, durationMs: 7800, spawnIntervalMs: 350 },
    {
      start: 7,
      end: 14,
      maxActive: 2,
      durationMs: 6500,
      spawnIntervalMs: 2800,
    },
    {
      start: 15,
      end: 20,
      maxActive: 3,
      durationMs: 5500,
      spawnIntervalMs: 1700,
    },
  ] as const,
});

export function multiplierFor(streak: number): Multiplier {
  if (streak >= 10) return 4;
  if (streak >= 6) return 3;
  if (streak >= 3) return 2;
  return 1;
}

export function phaseForOrdinal(ordinal: number) {
  const phase = GAME_RULES.phases.find(
    ({ start, end }) => ordinal >= start && ordinal <= end,
  );
  if (!phase) throw new RangeError(`No phase for ordinal ${ordinal}`);
  return phase;
}
